/**
 * How tall a column's filter dropdown may grow.
 *
 * Taller than the DropdownList default so a long list of options is worth
 * scanning, but tied to the viewport: the dropdown hangs off a table header,
 * so a fixed height that suits a desktop runs off the bottom of a laptop.
 */
export const FILTER_DROPDOWN_MAX_HEIGHT = 'min(65vh, 560px)';

/**
 * Characters before a filter dropdown queries the server.
 *
 * One or two characters match most of the tenant and cost a request per
 * keystroke to say so. Matches the minimum used elsewhere for server-backed
 * option lists.
 */
export const FILTER_SEARCH_MIN_LENGTH = 3;
